import { Injectable } from '@angular/core';

import { RepositoryService } from '@_services/api/repository.service';
import { GeneratedOrganizationStratalotTodoRuleApiService } from './organization-stratalot-todo-rule-api-generated.service';

@Injectable({
  providedIn: 'root'
})
export class OrganizationStratalotTodoRuleApiService extends GeneratedOrganizationStratalotTodoRuleApiService {
  constructor(repo: RepositoryService) {
    super(repo);
  }
}
